(function() {
  if (window.__kkWishInit) return;
  window.__kkWishInit = true;

  var waitForWK = window.KKWaitForWK; // shared poller (assets/kkumi-wishlist-king.js)

  // Sitewide save/remove toasts. These hearts live on product cards across the
  // whole theme (no single hosting section), so the copy is read from the global
  // wishlist config (window.__kkWishCfg.toasts, set in layout/theme.liquid) with
  // the original literals as the fallback — the toasts render identically until a
  // merchant overrides them.
  var WISH_CFG = (window.__kkWishCfg && window.__kkWishCfg.toasts) || {};
  var TOASTS = {
    added: WISH_CFG.added || 'Added to wishlist',
    removed: WISH_CFG.removed || 'Removed from wishlist',
    addError: WISH_CFG.addError || "Couldn't add to wishlist. Please try again.",
    removeError: WISH_CFG.removeError || "Couldn't remove from wishlist. Please try again."
  };

  // Global floating toast
  var toastEl = document.createElement('div');
  toastEl.className = 'kk-wish-toast-global';
  toastEl.setAttribute('aria-live', 'polite');
  document.body.appendChild(toastEl);

  var toastTimer;
  function showToast(btn, msg, opts) {
    var isError = opts && opts.error;
    // Try PDP-specific toast first
    var localToast = btn.parentElement && btn.parentElement.querySelector('.kk-hero__wish-toast');
    if (localToast) {
      localToast.textContent = msg;
      localToast.classList.toggle('is-error', !!isError);
      localToast.classList.remove('is-visible');
      void localToast.offsetWidth;
      localToast.classList.add('is-visible');
      setTimeout(function() { localToast.classList.remove('is-visible'); }, isError ? 3600 : 2200);
      return;
    }
    // Global floating toast for collection cards
    clearTimeout(toastTimer);
    var rect = btn.getBoundingClientRect();
    toastEl.textContent = msg;
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.style.top = (rect.top + window.scrollY - 40) + 'px';
    // Clamp left so toast stays within viewport (16px margin each side)
    var rawLeft = rect.left + rect.width / 2;
    var toastW = toastEl.offsetWidth || 120;
    var minLeft = toastW / 2 + 16;
    var maxLeft = window.innerWidth - toastW / 2 - 16;
    toastEl.style.left = Math.min(Math.max(rawLeft, minLeft), maxLeft) + 'px';
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    toastTimer = setTimeout(function() { toastEl.classList.remove('is-visible'); }, isError ? 3600 : 2200);
  }

  waitForWK(function(WK) {
    var apiHost = WK.config.routes.apiHost;
    var headers = WK._apis.wishlist.headers;
    // Keyed by "productId|variantId" so distinct variants of a product are
    // tracked independently ('' variant = no specific variant). value = item id.
    var wishlisted = {};

    function normVid(v) { v = (v == null) ? '' : String(v); return /^\d+$/.test(v) ? v : ''; }
    function keyOf(pid, vid) { return String(pid) + '|' + normVid(vid); }
    function btnKey(btn) { return keyOf(btn.dataset.productId, btn.dataset.variantId); }

    function syncButtons() {
      document.querySelectorAll('.kkumi-card__wish[data-product-id]').forEach(function(btn) {
        var active = Boolean(wishlisted[btnKey(btn)]);
        btn.classList.toggle('wk-active', active);
        btn.classList.add('wk-ready');
        // Don't touch wk-loading here — per-action handlers control that
        // independently. The initial page-load loading state is cleared by
        // clearInitialLoading() after loadWishlist() resolves.
        btn.disabled = false;
        var icon = btn.querySelector('.kkumi-card__wish-icon');
        if (icon) icon.style.fill = active ? 'currentColor' : 'none';
        // Product cards carry both labels (data-label-add / -remove); keep the
        // pressed state + spoken label in step with the heart. Attribute
        // writes only — safe under the cart's childList observers.
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var lbl = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
        if (lbl && btn.getAttribute('aria-label') !== lbl) btn.setAttribute('aria-label', lbl);
      });
    }

    function clearInitialLoading() {
      document.querySelectorAll('.kkumi-card__wish.wk-loading').forEach(function(btn) {
        if (!btn._kkActionLoading) btn.classList.remove('wk-loading');
      });
    }

    function loadWishlist() {
      return fetch(apiHost + '/wishlists/mine', { headers: headers })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          wishlisted = {};
          if (data && data.wishlist && data.wishlist.items) {
            data.wishlist.items.forEach(function(item) {
              wishlisted[keyOf(item.productId, item.variantId)] = item.id;
            });
          }
          syncButtons();
          clearInitialLoading();
        })
        .catch(function() { syncButtons(); clearInitialLoading(); });
    }

    document.querySelectorAll('.kk-hero__wishlist.wk-loading').forEach(function(btn) {
      btn.disabled = true;
    });

    loadWishlist();

    // Re-apply heart states to cards inserted by the collection AJAX filter
    // (and any other section that fires the event after injecting new cards
    // — e.g. Dawn's <product-recommendations>). syncButtons paints the
    // wk-active state from the cached wishlist, then clearInitialLoading
    // removes the placeholder wk-loading on the newly-arrived hearts.
    document.addEventListener('kkumi:collection:updated', function() {
      syncButtons();
      clearInitialLoading();
    });

    // Variant-level saves: when the PDP variant changes, point the hero heart at
    // the new variant and re-paint its saved state (the new variant may or may
    // not be in the wishlist independently of the previously-shown one).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function(payload) {
        var v = payload && payload.data && payload.data.variant;
        if (!v || v.id == null) return;
        document.querySelectorAll('.kk-pdp-wish-slot.kkumi-card__wish').forEach(function(btn) {
          btn.dataset.variantId = v.id;
        });
        syncButtons();
      });
    }

    function fetchWishlistItem(pid, vid) {
      // Cache-bust + no-store so polled checks see fresh server state
      // (the API can hand back stale snapshots from CDN/edge otherwise).
      var url = apiHost + '/wishlists/mine?_t=' + Date.now();
      var want = keyOf(pid, vid);
      return fetch(url, { headers: headers, cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var items = (data && data.wishlist && data.wishlist.items) || [];
          return items.find(function(i) { return keyOf(i.productId, i.variantId) === want; }) || null;
        });
    }

    function startLoading(btn) {
      btn._kkActionLoading = true;
      btn.classList.add('wk-loading');
    }
    function stopLoading(btn) {
      btn._kkActionLoading = false;
      btn.classList.remove('wk-loading');
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.kkumi-card__wish');
      if (!btn || btn.disabled) return;
      // While an action is in flight on this button, ignore further clicks.
      if (btn._kkActionLoading) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.dataset.productHandle;
      var pid = btn.dataset.productId;
      var vid = Number(btn.dataset.variantId) || 0;
      var key = btnKey(btn);

      var willAdd = !wishlisted[key];
      var previousId = wishlisted[key];

      // Show spinner. Do NOT change wk-active yet — the heart stays in its
      // current state until the server confirms the action succeeded.
      startLoading(btn);

      function failed(msg) {
        stopLoading(btn);
        syncButtons(); // re-paints wk-active from unchanged wishlisted[]
        showToast(btn, msg, { error: true });
      }

      if (willAdd) {
        // Fire-and-forget: verifySettled() below is the source of truth for the
        // heart's final state, so swallow a rejected save here (addWishlistItem
        // rejects on a failed save) — the verify re-check drives the error toast.
        // A configured bundle's heart carries its current choices
        // (data-kk-wish-properties, kept current by kkumi-sb-options.js) so
        // they're saved with the item and restored when it's added back.
        var props = null;
        try { props = btn.dataset.kkWishProperties ? JSON.parse(btn.dataset.kkWishProperties) : null; } catch (err) { props = null; }
        WK.addWishlistItem({
          productHandle: handle,
          productId: Number(pid),
          variantId: vid,
          inWishlist: false,
          properties: props || undefined
        }).catch(function() {});
        verifySettled(pid, vid, true).then(function(result) {
          if (result.ok && result.item) {
            wishlisted[key] = result.item.id;
            stopLoading(btn);
            syncButtons();
            showToast(btn, TOASTS.added);
          } else {
            failed(TOASTS.addError);
          }
        }, function() {
          failed(TOASTS.addError);
        });
      } else {
        // We need a real wishlistItemId to DELETE. previousId is preferred;
        // fall back to a fresh lookup if it's still the boolean placeholder.
        var hasRealId = typeof previousId === 'number' ||
                        (typeof previousId === 'string' && previousId);
        var idPromise = hasRealId
          ? Promise.resolve(previousId)
          : fetchWishlistItem(pid, vid).then(function(item) { return item ? item.id : null; });

        idPromise.then(function(realId) {
          if (!realId) {
            // Server says it's not there — already removed. Clean local cache.
            delete wishlisted[key];
            stopLoading(btn);
            syncButtons();
            return;
          }
          WK.removeWishlistItem({
            productHandle: handle,
            wishlistItemId: realId,
            productId: Number(pid),
            variantId: vid,
            inWishlist: true
          });
          verifySettled(pid, vid, false).then(function(result) {
            if (result.ok) {
              delete wishlisted[key];
              stopLoading(btn);
              syncButtons();
              showToast(btn, TOASTS.removed);
            } else {
              failed(TOASTS.removeError);
            }
          }, function() {
            failed(TOASTS.removeError);
          });
        }, function() {
          failed(TOASTS.removeError);
        });
      }
    });

    // Verifies the server reached the expected state after a WK add/remove.
    // At most 2 fetches: one ~500ms after the WK call (gives the API time
    // to commit), and one more 1s later if the first check disagreed.
    // Returns { ok, item } — ok=true means the server confirmed the
    // expected presence/absence.
    function verifySettled(pid, vid, expectedToExist) {
      function check() {
        return fetchWishlistItem(pid, vid).then(function(item) {
          var matches = expectedToExist ? !!item : !item;
          return { ok: matches, item: item };
        });
      }
      return new Promise(function(resolve) {
        setTimeout(function() {
          check().then(function(r1) {
            if (r1.ok) return resolve(r1);
            setTimeout(function() {
              check().then(resolve, function() { resolve({ ok: false, item: null }); });
            }, 1000);
          }, function() {
            resolve({ ok: false, item: null });
          });
        }, 500);
      });
    }

  });
})();
